<template>
  <div>
    <loader v-show="isPending" class="c-loader" />
    <div v-if="!isPending">
      <div class="d-xl-none">
        <mobile-facets>
          <template #title>
            {{ getProductOverviewTranslations['ProductsOverview.ShowFilters'] }}
          </template>

          <template #view-results>
            {{ getProductOverviewTranslations['ProductsOverview.ShowResults'] }}
          </template>

          <facet
            v-for="(facet, key) in sortedFacets"
            :key="key + '_' + facet.propertyId"
            :facet="facet"
            :facet-key="key"
          />
        </mobile-facets>
      </div>

      <div class="d-none d-xl-flex c-facets__wrapper">
        <reset-filters />
        <facet
          v-for="(facet, key) in sortedFacets"
          :key="key + '_' + facet.propertyId"
          :facet="facet"
          :facet-key="key"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Facet from './facet.vue';
import Loader from './loader.vue';
import ResetFilters from './reset-filters.vue';
import MobileFacets from './mobile-facets.vue';

export default {
  components: {
    Facet,
    Loader,
    ResetFilters,
    MobileFacets
  },
  computed: {
    ...mapGetters('productSearch', ['mapFacets']),
    ...mapGetters('translations', ['getProductOverviewTranslations']),
    ...mapState('productSearch', ['isPending', 'propertiesMetadata']),
    sortedFacets() {
      const sortedFacets = Object.entries(this.mapFacets)
        .filter(([, x]) => x.metadata.filterPosition > 0)
        .sort(
          ([, a], [, b]) =>
            a.metadata.filterPosition - b.metadata.filterPosition
        )
        .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
      return sortedFacets;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/src/utilities/_variables.scss';
@import '@/css/src/utilities/_mixins.scss';
@import '~bootstrap/scss/mixins';

.c-loader {
  padding-top: 60px;
}

.c-facets {
  &__wrapper {
    flex-direction: column;
    row-gap: 45px;
  }
}
</style>
